export const ITPMETRICS_BLUE = '#253e65';
export const ITPMETRICS_YELLOW = '#E0B155'; // #f5ce20, #E3B066
export const ITPMETRICS_BLUE_LIGHT = '#253e6540';
export const ITPMETRICS_YELLOW_LIGHT = '#E0B15540';
export const ITPMETRICS_GREEN = 'rgb(83, 129, 59)';
export const ITPMETRICS_PURPLE = 'rgb(148, 33, 143)';
